export enum FormFields {
	BeginCheckout = 'begin_checkout',
	SubmitContactInfo = 'submit_contact_info',
	SubmitBillingInfo = 'submit_billing_info',
	AddPaymentInfo = 'add_payment_info',
	Invoice = 'invoice'
}
